"use client";

import { c as _c } from "react/compiler-runtime";
import { Chip as HeroChip } from "@heroui/react";
import { cn } from "../../lib/utils";
import chipStyles from "./Chip.module.css";
type HeroChipColor = React.ComponentProps<typeof HeroChip>["color"];
type ExtendedColor = HeroChipColor | "pop" | "punch" | "soft";
interface ChipProps extends Omit<React.ComponentProps<typeof HeroChip>, "color"> {
  className?: string;
  color?: ExtendedColor;
}
export const Chip = t0 => {
  const $ = _c(13);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "default" : t1;
  const {
    radius,
    variant: t2
  } = props;
  const variant = t2 === undefined ? "solid" : t2;
  const heroChipColor = color === "pop" || color === "punch" || color === "soft" ? "primary" : color as HeroChipColor;
  let t3;
  if ($[4] !== className) {
    t3 = cn(chipStyles.chip, className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== color || $[7] !== heroChipColor || $[8] !== props || $[9] !== radius || $[10] !== t3 || $[11] !== variant) {
    t4 = <HeroChip color={heroChipColor} data-color={color} data-radius={radius} data-variant={variant} className={t3} {...props} />;
    $[6] = color;
    $[7] = heroChipColor;
    $[8] = props;
    $[9] = radius;
    $[10] = t3;
    $[11] = variant;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};